import { useQuery } from "@tanstack/react-query";
import { fetchStats } from "@/lib/practicesService";

export function usePracticeStats() {
  return useQuery({
    queryKey: ["practice-stats"],
    queryFn: fetchStats,
    staleTime: 5 * 60 * 1000,
  });
}